import React from 'react'
import AmbulatoryCidsLayout from 'presentation/doctor/layouts/AmbulatoryCids'

function AmbulatoryCids() {
  return <AmbulatoryCidsLayout />
}

export default AmbulatoryCids
